module.exports = __webpack_public_path__ + "img/1560932103.7d8bf867.jpg";